module.exports = __webpack_public_path__ + "img/screening.4ccff276.png";